import { Moment } from "moment";
import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateEndTimeOpenShift", function updateEndTimeOpenShift(newTime: Moment) {
    if (shiftEditorViewState().openShift && newTime) {
        shiftEditorViewState().openShift.endTime = newTime.clone();
    }
});